import { MediaCard, MediaCardProps } from "@kaltura/mediaspace-shared-media-list";
import { KalturaBaseEntryWithUserEntry, ProgressBarConfig } from "../MyHistory";
import { KalturaMediaType } from "kaltura-typescript-client/api/types/KalturaMediaType";
import { KalturaUserEntryExtendedStatus } from "kaltura-typescript-client/api/types/KalturaUserEntryExtendedStatus";

export interface MyHistoryMediaCardProps extends MediaCardProps {
    progressBarConfig: ProgressBarConfig;
}

/**
 * MediaCard component for My History that includes progress bar
 */
export const MyHistoryMediaCard = (props: MyHistoryMediaCardProps) => {
    const { progressBarConfig, ...restProps } = props;
    const { media } = restProps;
    const historyEntry = media.object as KalturaBaseEntryWithUserEntry;

    const shouldShowProgressBar =
        [KalturaMediaType.video, KalturaMediaType.audio].includes(historyEntry.mediaType)
        && historyEntry.userEntry.extendedStatus !== KalturaUserEntryExtendedStatus.viewed;

    const { endSeconds, endPercent } = progressBarConfig;

    const getProgressValue = () => {
        const lastTimeReached = Math.min(historyEntry.userEntry.lastTimeReached, historyEntry.duration);

        let progressValue = historyEntry.duration > 0 ? Math.ceil((lastTimeReached / historyEntry.duration) * 100) : 0;

        // If playback is complete and it meets the threshold, show 100%
        if (
            historyEntry.userEntry.extendedStatus === KalturaUserEntryExtendedStatus.playbackComplete
            && (endPercent <= progressValue || endSeconds >= historyEntry.duration - lastTimeReached)
        ) {
            progressValue = 100;
        }

        return progressValue;
    };

    const progress = !shouldShowProgressBar ? undefined : getProgressValue();

    return <MediaCard {...restProps} progressValue={progress} />;
};

export default MyHistoryMediaCard;
